module.exports = __webpack_public_path__ + "static/img/IMG_20160222_113133.920d8b40.jpg";